// client/src/api/ApiLeagueEmailSettings.js
import flex from './FlexFetch'
import { unwrapStrictPayload } from './listPayloadUtils'

const endpoint = '/api/1.0/league-email-settings/'

/**
 * Get email draft automation settings for a league
 * @param {number} leagueId - League ID
 * @returns {Promise} Settings object
 */
async function getSettings(leagueId) {
  const params = new URLSearchParams({ league_id: leagueId })
  const response = await flex.flexFetch(endpoint + `get?${params}`)
  return unwrapStrictPayload(await flex.handleResponse(response))
}

/**
 * Update email draft automation settings for a league
 * @param {number} leagueId - League ID
 * @param {Object} settings - Settings to update
 * @param {boolean} settings.draft_schedule_enabled - Enable/disable scheduling
 * @param {number} settings.draft_schedule_day - Day of week (0=Sunday, 6=Saturday)
 * @param {string} settings.draft_schedule_time - Time in HH:MM:SS format
 * @param {string} settings.draft_schedule_timezone - Timezone string
 * @returns {Promise} Updated settings object
 */
async function updateSettings(leagueId, settings) {
  const response = await flex.flexFetch(endpoint + 'update', {
    method: 'PUT',
    body: JSON.stringify({ league_id: leagueId, ...settings }),
  })
  return unwrapStrictPayload(await flex.handleResponse(response))
}

const ApiLeagueEmailSettings = {
  getSettings,
  updateSettings,
}

export default ApiLeagueEmailSettings
